import SVG from './SVG'

export const SearchBoldSVG = (props) => {
  return (
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_22219_437485)" className="search-bold">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.5 5.5C2.5 3.84315 3.84315 2.5 5.5 2.5C7.15685 2.5 8.5 3.84315 8.5 5.5C8.5 6.29735 8.18893 7.02205 7.68153 7.55936C7.65967 7.57777 7.63842 7.59727 7.61784 7.61784C7.59727 7.63842 7.57777 7.65967 7.55936 7.68153C7.02205 8.18893 6.29735 8.5 5.5 8.5C3.84315 8.5 2.5 7.15685 2.5 5.5ZM8.25739 9.6716C7.46696 10.1951 6.51908 10.5 5.5 10.5C2.73858 10.5 0.5 8.26142 0.5 5.5C0.5 2.73858 2.73858 0.5 5.5 0.5C8.26142 0.5 10.5 2.73858 10.5 5.5C10.5 6.51908 10.1951 7.46696 9.6716 8.25739L11.2071 9.79284C11.5976 10.1834 11.5976 10.8165 11.2071 11.2071C10.8165 11.5976 10.1834 11.5976 9.79284 11.2071L8.25739 9.6716Z"
          fill="#4A4A4A"
        />
      </g>
    </SVG>
  )
}
